export default __webpack_public_path__ + "static/media/Facebook.4528df7c.svg";